function AddressMeedyVO(id, zipCode, state, country, street, number, apartment, city) {

    this.id = id;
    this.zipCode = zipCode;
    this.state = state;
    this.country = country;
    this.street = street;
    this.number = number;
    this.apartment = apartment;
    this.city = city;

    var _typeContext = {
        country : CountryMeedyVO,
        state : StateMeedyVO
    };

    this.getAddressString = function() {
        var addressString =  '';
        
        if (this.street) {
            addressString += this.street;
        }
        if (this.apartment) {
            if (addressString.length > 0) {
                addressString += ' '
            }
            addressString += this.apartment;
        }
        if (this.number && this.apartment) {
            addressString += '/ ' + this.number;
        }
        if (this.zipCode) {
            if (addressString.length > 0) {
                addressString += ', '
            }
            addressString += this.zipCode;
        }
        if (this.city) {
            if (addressString.length > 0) {
                addressString += ' '
            }
            addressString += this.city;
        }
        if (this.country) {
            if (addressString.length > 0) {
                addressString += ', '
            }
            addressString += this.country;
        }

        return addressString
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
